import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-legal-footer',
  standalone: true,
  imports: [],
  templateUrl: './legal-footer.component.html',
  styleUrl: './legal-footer.component.scss',
})
export class LegalFooterComponent {
  // The atlas icon moves here whenever the commune's own logo takes its
  // place (as home button) in the menu bar.
  @Input() showAtlasIcon = false;

  readonly links = [
    { label: 'Impressum', url: 'https://www.keck-atlas.de/system/impressum' },
    {
      label: 'Datenschutz',
      url: 'https://www.keck-atlas.de/system/datenschutz',
    },
  ];
}
